import Toast                           from "_common/toast";
import { thankForDonationMutationAPI } from "_services/api/broadcast";

export const updateThankForDonation = async ( { sessionId, commentId } ) => {
	if ( !sessionId )
		return;

	try {
		await thankForDonationMutationAPI ( { sessionId, commentId } );

	} catch ( error ) {
		Toast.error ( "Some error occured. Please try again later." );
	}
};